import React from 'react'
import { useTranslation } from 'react-i18next'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { withStyles } from '@mui/styles'

const BlueCheckbox = withStyles({
  // root: {
  //   color: "#1083c6",
  //   "&$checked": {
  //     color: "#1083c6"
  //   }
  // },
  // checked: {}
})((props: CheckboxProps) => (
  <Checkbox
    color='default'
    {...props}
  />
))

const CustomCheckbox: ReactFC<any> = (props) => {
  const { t } = useTranslation()
  return (
    <FormControlLabel
      control={(
        <BlueCheckbox
          // checked={state.checkedB}
          // onChange={handleChange}
          {...props}
        />
      )}
      label={`${t('labels.remember_me')}`}
    />
  )
}

export default CustomCheckbox
